import type { InternalAdTargeting } from '../types'

export function mergeTargeting(current: InternalAdTargeting, incoming: InternalAdTargeting): void {
    const target = current as Record<string, string | undefined>
    for (const key in incoming) {
        const value = incoming[key as keyof InternalAdTargeting]
        if (value) {
            target[key] = value
        } else {
            delete target[key]
        }
    }
}
